import styles from "./customer.module.css";
import { FaUserEdit, FaTelegramPlane } from "react-icons/fa";
import { BsStarHalf } from "react-icons/bs";
import { AiFillDelete } from "react-icons/ai";
import { TbReportAnalytics } from "react-icons/tb";
import Modal from "./modal/Modal";
import ReactTooltip from "react-tooltip";
import { useState, useEffect, useContext } from "react";
import { map } from "lodash";
import ReportModal from "./modal/ReportModal.jsx";

const BoxCustomer = ({
  item,
  deleteHandler,
  index,
  customers,
  setCustomers,
  setSelectedItem,
  setModalUpdate,
  setModalMsg,
  ChosenPeople,
  setchosenPeople,
}) => {
  const editHandler = () => {
    setSelectedItem(index);
    setModalUpdate((prev) => !prev);
  };
  const [tags, setTags] = useState([]);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  // useEffect(() => {
  //   let temp = [];
  //   customers[index] &&
  //     customers[index].tags.map((item, index) => {
  //       temp.push({ id: index, label: item.title, value: item.id });
  //     });
  //   console.log(temp, "temp");
  //   setTags(temp);
  // }, [customers[index]]);

  // useEffect(() => {
  //   console.log(items, "ColumnName");
  // }, [items]);

  return (
    <>
      <ReactTooltip />
      <div
        className={`  w-100  ${
          item.main_status == 1 ? styles.gry : styles.sec
        }`}
        style={{
          borderRadius: " 10px",
        }}
      >
        <div className={`d-flex flex-wrap ${styles.secondry}`}>
          <div className={styles.BlueCol}>
            <p
              className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
            >
              انتخاب
            </p>
            <p
              className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
            >
              <input
                type="checkbox"
                checked={ChosenPeople.includes(customers[index].users__id)}
                className="mx-auto form-check-input"
                onChange={(e) => {
                  if (e.target.checked) {
                    setchosenPeople([
                      ...ChosenPeople,
                      customers[index].users__id,
                    ]);
                  } else {
                    setchosenPeople(
                      ChosenPeople.filter(
                        (item) => item != customers[index].users__id
                      )
                    );
                  }
                }}
              />
            </p>
          </div>
          <div className={styles.BlueCol}>
            <p
              className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
            >
              نام و نام خانوادگی
            </p>
            <p
              className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
            >
              {item.fullname}{" "}
            </p>
          </div>
          <div className={styles.BlueCol}>
            <p
              className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
            >
              شماره همراه{" "}
            </p>
            <p
              className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
            >
              {item.mobile}{" "}
            </p>
          </div>
          <div className={styles.BlueCol}>
            <p
              className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
            >
              وضعیت{" "}
            </p>
            <p
              className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
            >
              {item.main_status == 1
                ? "غیر فعال"
                : item.main_status == 0
                ? " فعال"
                : ""}
            </p>
          </div>
          <div className={styles.BlueCol}>
            <p
              className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
            >
              کد ملی{" "}
            </p>
            <p
              className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
            >
              {item.codemeli}{" "}
            </p>
          </div>

          {/* <div className={styles.BlueCol}>
            <p
              className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
            >
              برچسب{" "}
            </p>
            <p
              className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
            >
              {customers[index] &&
                tags.map((item, index) => (
                  <span className={styles.spn}>{item.label}</span>
                ))}
            </p>
          </div> */}
          <div className={styles.BlueCol}>
            <p
              className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
            >
              عملیات{" "}
            </p>
            <div
              className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
            >
              <p
                className={styles.tlg}
                data-bs-toggle="modal"
                data-bs-target="#editModal"
                onClick={editHandler}
                data-tip="ویرایش"
              >
                <FaUserEdit />
              </p>
              <p
                className={styles.tlg}
                data-bs-toggle="modal"
                data-bs-target="#deleteModal"
                onClick={editHandler}
                data-tip="حذف"
              >
                <AiFillDelete />
              </p>
              <FaTelegramPlane
                data-bs-toggle="modal"
                data-bs-target="#SendMsgModal"
                className={styles.tlg}
                onClick={editHandler}
                data-tip="ارسال پیام"
              />{" "}
              <BsStarHalf
                data-bs-toggle="modal"
                data-bs-target="#coinModal"
                className={styles.tlg}
                onClick={editHandler}
                data-tip="امتیازدهی "
              />
              <TbReportAnalytics
                data-bs-toggle="modal"
                data-bs-target="#reportModal"
                data-tip="گزارش"
                // show={handleShow}
                // setShow={setShow}
                className={styles.tlg}
                onClick={() => {
                  // handleShow();
                  editHandler();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BoxCustomer;
